import { render } from "./VerificationInput.vue?vue&type=template&id=ed31d6f4&scoped=true"
import script from "./VerificationInput.vue?vue&type=script&lang=js"
export * from "./VerificationInput.vue?vue&type=script&lang=js"

import "./VerificationInput.vue?vue&type=style&index=0&id=ed31d6f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed31d6f4"]])

export default __exports__